import React from 'react';

// Barcode label. Shared by the sidebar (small, grey) and dashboard tile (D9).
export const BarcodeLabelPath = ({ fill }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm3 2v9h1.2V7H7Zm2.2 0v9h.6V7h-.6Zm1.6 0v9h1.6V7h-1.6Zm2.6 0v9h.6V7h-.6Zm1.6 0v9h1.2V7H15Zm2.2 0v9h.8V7h-.8ZM7 18v1.5h11V18H7Z"
    fill={fill}
  />
);

const MarketplaceLabels = (props) => (
  <svg width={25} height={26} viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <BarcodeLabelPath fill="#707070" />
  </svg>
);
export default MarketplaceLabels;
